import "core-js/modules/es6.object.freeze";
import { colors, colorsRefresh } from '../colors';
import { shadows } from '../shadows';
import { strokeWidths, strokeWidthsRefresh } from '../stroke-widths';
export var card = Object.freeze({
  border: 'none',
  boxShadow: shadows.box["default"],
  headerBorder: strokeWidths["default"] + " solid " + colors.snow
});
export var cardRefresh = Object.freeze({
  border: strokeWidthsRefresh["default"] + " solid " + colorsRefresh.gray4,
  boxShadow: 'none',
  headerBorder: strokeWidthsRefresh["default"] + " solid " + colorsRefresh.gray4
});